import { clone, findIndex, propEq, path } from 'ramda';

export default (initialData, data) => {
  const result = clone(initialData);
  for (const field in data) {
    const { permAreaKey, permTypeKey, value } = data[field];
    const key = findIndex(propEq('permAreaKey', permAreaKey))(result['fields']);
    const containerWithInputs = path(['fields', key, 'permissions', permTypeKey, 'inputs'], result);
    if (containerWithInputs) {
      const inputsCount = containerWithInputs.length;

      switch (value) {
        case 'on':
          if (inputsCount > 1) {
            containerWithInputs[1].value = true;
          }
          containerWithInputs[0].value = true;
          break;
        case 'off':
          if (inputsCount > 1) {
            containerWithInputs[1].value = false;
          }
          containerWithInputs[0].value = false;
          break;
        case 'own':
          if (inputsCount > 1) {
            containerWithInputs[1].value = false;
          }
          containerWithInputs[0].value = true;
          break;
      }
    }
  }
  return result;
}


// WEBPACK FOOTER //
// ./src/containers/RoleEdit/mapPermissionValues.js